import type { TypeChatChannel, TypeChatMember } from '@/types/conversation/types.conversation.chat.channel';
import type { TypeChatMessage } from '@/types/conversation/types.conversation.chat.message';

const MAX = 140;

const clip = (text: string) => {
    const flat = text.replace(/\s+/g, ' ').trim();
    return flat.length > MAX ? `${flat.slice(0, MAX - 1)}…` : flat;
};

export function chatNotifyBody(message: TypeChatMessage, channel: TypeChatChannel, members: TypeChatMember[], me: string | null, preview: boolean): { title: string; body: string } {
    const author = members.find((member) => member.id === message.authorId)?.name ?? 'Un collega';
    const mention = Boolean(me && message.mentions.includes(me));
    const title = channel.kind === 'group' ? `${author} · ${channel.name}` : author;
    if (!preview) return { title, body: mention ? 'Ti ha menzionato' : 'Nuovo messaggio' };
    if (message.unreadable) return { title, body: 'Messaggio che non si può leggere' };
    if (message.poll) return { title, body: clip(`${message.poll.mode === 'proposal' ? 'Proposta' : 'Sondaggio'}: ${message.poll.question}`) };
    if (message.contact) return { title, body: clip(`Contatto: ${message.contact.name}`) };
    const files = Math.max(message.attachments.length, message.expectedFiles);
    const parts = [message.text ? clip(message.text) : '', files ? (files === 1 ? 'Ha mandato un file' : `Ha mandato ${files} file`) : '', !message.text && message.references[0] ? `Collegamento: ${message.references[0].title}` : ''].filter(Boolean);
    return { title, body: parts.join(' · ') || 'Nuovo messaggio' };
}

export default chatNotifyBody;
